import React, { FC, useCallback, useLayoutEffect, useState } from 'react';
import { createProvider } from '../../../../utils/createProvider';
import { useUserPageContextState } from '../../../user';
import { entityTypeIds } from '../../../../utils/const';

type ListFilterBreadcrumbCollapseProviderValue = {
	isCollapsed: boolean;
	visibleItemsCount: number | undefined;
	toggleCollapse: () => void;
};

const [Provider, useListFilterBreadcrumbCollapseProvider] = createProvider<ListFilterBreadcrumbCollapseProviderValue>({
	contextName: 'ListFilterBreadcrumbCollapseContext',
});

const ListFilterBreadcrumbCollapseProvider: FC<React.PropsWithChildren> = ({ children }) => {
	const { organizationTypeId } = useUserPageContextState();

	const isCandidateOrEmployer =
		organizationTypeId === entityTypeIds.CANDIDATE || organizationTypeId === entityTypeIds.EMPLOYER;
	const visibleItemsCount = isCandidateOrEmployer ? 5 : 10;

	const [isCollapsed, setIsCollapsed] = useState(false);

	useLayoutEffect(() => {
		setIsCollapsed(true);
	}, []);

	const toggleCollapse = useCallback(() => {
		setIsCollapsed((prev) => !prev);
	}, []);

	return (
		<Provider
			value={{
				isCollapsed,
				visibleItemsCount,
				toggleCollapse,
			}}
		>
			{children}
		</Provider>
	);
};

export { ListFilterBreadcrumbCollapseProvider, useListFilterBreadcrumbCollapseProvider };
